import {httpResource} from '@angular/common/http';
import {VacatureInfo} from '../models/vacature-info';
import {inject, Service} from '@angular/core';
import {MV_GATEWAY_URL} from '../app.config';

@Service()
export class VacatureService {

  private readonly gatewayUrl = inject(MV_GATEWAY_URL);

  readonly vacatureInfo = httpResource<VacatureInfo>(() => this.gatewayUrl + '/api/ui/vacatures');

}
